// @ts-nocheck
import {
  Platform,
  Pressable,
  StatusBar,
  View,
  useWindowDimensions,
  StyleSheet,
} from 'react-native';
import React from 'react';
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context';
import {} from 'react-native-paper';
import {useDispatch, useSelector} from 'react-redux';
import Menu from './Menu';
import {SignOut} from '../modules/Auth/reducer';
import Ionicon from '@expo/vector-icons/Ionicons';
import MaterialCommunityIcon from '@expo/vector-icons/MaterialCommunityIcons';
import {RootStore} from '../redux/store';
import IconButton from '../components/IconButton';
import Text from '../components/Text';
import ConfirmationDialog from './ConfirmationDialog';
import {Center, HStack} from 'native-base';
import { colorSwatches } from '../styles';
import PermissionsBanner from '../modules/More/components/PermissionsBanner';
import { E_NAVIGATION_DESTINATIONS } from '../@types';
import { useAppSelector } from '../hooks/redux';
import DefaultUnitLabel from './DefaultUnitLabel';
import { deriveUnitName } from '../utils/deriveDisplayName';
import { useFoldable } from '../hooks/useFoldable';
import PendingApprovalsBadge from './PendingApprovalsBadge';

type NavbarProps = {
  navigation: {
    goBack: Function;
  };
  title: string;
  hasBackArrow?: boolean;
  hasSearch?: boolean;
  hasFilter?: boolean;
  onClickFilter?: Function;
  hasAccessCard?: boolean;
  onClickAccessCard?: Function;
  hasAdd?: boolean;
  hasSignOut?: boolean;
  onClickAdd?: Function;
  onClickSearch?: Function;
  showCurrentUnit?: boolean;
  showUnitPicture?: boolean;
  hasMoreMenu?: boolean;
  hasProfile?: boolean;
  openProfile?: Function;
  hasReadAll?: boolean;
  readAll?: Function;
  hasSwitchUnit?: boolean;
  switchUnit?: Function;
  fullScreen?: boolean;
  hasGenerateInviteCode?: boolean;
  onClickGenerateInviteCode?: () => void;
  showDefaultUnitLabel?: boolean;
};

const NavbarWithAction = (props: NavbarProps) => {
  const {
    navigation,
    title,
    hasBackArrow,
    hasSearch,
    hasFilter,
    onClickFilter,
    hasAccessCard,
    onClickAccessCard,
    hasAdd,
    hasSignOut,
    onClickAdd,
    onClickSearch,
    showCurrentUnit,
    showUnitPicture,
    hasMoreMenu,
    hasProfile,
    openProfile,
    hasReadAll,
    readAll,
    hasSwitchUnit,
    switchUnit,
    fullScreen,
    hasGenerateInviteCode,
    onClickGenerateInviteCode,
    hasOthers,
    openOthers,
    showDefaultUnitLabel = false,
  } = props;

  const defaultUnit = useSelector(
    (state: RootStore) => state?.units?.unitLinks,
  ).filter(link => link?.isDefault === true)[0];
   const unitName = defaultUnit ? deriveUnitName(defaultUnit) : 'N/A';
  const pictureUrl = defaultUnit?.profilePicture
    ? `data:image/jpeg;base64,${defaultUnit.profilePicture}`
    : 'http://cigated-v3.herokuapp.com/assets/images/unit.jpeg';

  const dispatch = useDispatch();
  const pendingOwnerApprovals = useAppSelector((state) =>
    state?.approvals?.approvals?.filter(
      approval => approval.residentApprovalStatus === 'Pending',
    ) ?? [],
  );
  const pendingOwnerApprovalsCount = pendingOwnerApprovals.length;
  const insets = useSafeAreaInsets();

  const {width} = useWindowDimensions();

  const isAuthorized = !!(useAppSelector((state) => state.auth?.user?.id));

  const isFoldable = useFoldable();
  const styles = createStyles(isFoldable);
  const topInset =
    Platform.OS === 'android'
      ? Math.max(insets.top, StatusBar.currentHeight ?? 0)
      : insets.top;
  const headerTopPadding = topInset + (isFoldable ? 10 : 0);

  const [isOpen, setIsOpen] = React.useState(false);
  const onClose = () => setIsOpen(false);

  const [isReadAllOpen, setIsReadAllOpen] = React.useState(false);
  const onCloseReadAll = () => setIsReadAllOpen(false);

  const onYesPressed = () => {
    dispatch(SignOut());
  };

  const onNoPressed = () => {
    console.log('Cancel Pressed');
  };

  const onApprovalsBadgePress = () => {
    navigation.navigate('Dashboard', {
      screen: 'Alerts',
      params: {activeTab: 'Pending approvals'},
    });
  };

  if (fullScreen) {
    return (
      <>
        <SafeAreaView
          edges={[]}
          style={[{
            backgroundColor: colorSwatches.primary.color,
            paddingTop: headerTopPadding,
          }]}>
          {isAuthorized && (
          <PermissionsBanner
            onPress={() =>
              navigation.navigate(E_NAVIGATION_DESTINATIONS.NOTIFICATION_SETTINGS)
            }
            />)}
          {showDefaultUnitLabel && <DefaultUnitLabel unitName={unitName} />}
          <View style={styles.navBar}>
            {hasBackArrow && (
              <IconButton
                icon={'arrow-back'}
                size={24}
                onPress={() => navigation.goBack()}
                iconColor={styles.iconColor.color}
              />
            )}
            {showCurrentUnit ? (
              <Text numberOfLines={1} style={styles.title}>{`Unit ${defaultUnit?.unitNickname
                  ? defaultUnit?.unitNickname
                  : defaultUnit?.unit?.unitName
                } ${title}`}</Text>
            ) : (
              <Text style={styles.title}>{title}</Text>
            )}
            {hasFilter && (
              <IconButton
                icon={'filter'}
                size={24}
                style={styles.iconButton}
                onPress={() => onClickFilter()}
                iconColor={styles.iconColor.color}
              />
            )}
            {hasAccessCard && !!defaultUnit && (
              <IconButton
                icon={({ color }) => (
                  <MaterialCommunityIcon
                    name="badge-account-horizontal-outline"
                    color={color}
                    size={24}
                  />
                )}
                style={styles.iconButton}
                onPress={() => onClickAccessCard()}
                iconColor={styles.iconColor.color}
              />
            )}
            {hasSearch && (
              <IconButton
                icon="search"
                size={24}
                onPress={() => onClickSearch()}
                iconColor={styles.iconColor.color}
              />
            )}
            <IconButton
              icon={'add'}
              size={28}
              onPress={() => (hasAdd ? onClickAdd() : null)}
              borderless
              style={{
                opacity: hasAdd ? 1 : 0,
              }}
              iconColor={
                hasAdd ? styles.iconColor.color : colorSwatches.primary.color
              }
            />
            {hasMoreMenu && (
              <Menu
                // placement="top"
                trigger={triggerProps => {
                  return (
                    <Pressable {...triggerProps} style={styles.moreMenu}>
                      <Ionicon
                        name="ellipsis-vertical"
                        size={22}
                        color={styles.iconColor.color}
                      />
                    </Pressable>
                  );
                }}>
                {hasProfile && (
                  <Menu.Item onPress={() => openProfile()}>Profile</Menu.Item>
                )}
                {hasOthers && (
                  <Menu.Item onPress={() => openOthers()}>Others</Menu.Item>
                )}
                {hasReadAll && (
                  <Menu.Item onPress={() => setIsReadAllOpen(true)}>
                    Mark all alerts as read
                  </Menu.Item>
                )}
                {hasGenerateInviteCode && (
                  <Menu.Item onPress={onClickGenerateInviteCode}>
                    Generate Linking Code
                  </Menu.Item>
                )}
                {hasSwitchUnit && (
                  <Menu.Item onPress={() => switchUnit()}>Switch unit</Menu.Item>
                )}
                {hasSignOut && (
                  <Menu.Item onPress={() => setIsOpen(!isOpen)}>Sign Out</Menu.Item>
                )}
              </Menu>
            )}
            <ConfirmationDialog
              isOpen={isOpen}
              onClose={onClose}
              onNoPressed={onNoPressed}
              onYesPressed={onYesPressed}
              description="Are you sure you wish to logout?"
            />
            <ConfirmationDialog
              isOpen={isReadAllOpen}
              onClose={onCloseReadAll}
              onNoPressed={onNoPressed}
              onYesPressed={readAll}
              description="Are you sure you wish to mark all alerts as read ?"
            />
          </View>
        </SafeAreaView>
        {!!pendingOwnerApprovalsCount && (
          <PendingApprovalsBadge
            pendingApprovals={pendingOwnerApprovalsCount}
            onPress={onApprovalsBadgePress}
          />
        )}
      </>
    );
  }

  return (
    <Center
      style={[styles.center, {paddingTop: headerTopPadding}]}
      id="navBarWithAction">
      <View style={styles.navBar}>
        <HStack
          style={{
            flex: 1,
            alignItems: 'center',
            width: width / 3 + 32,
          }}>
          {hasBackArrow && (
            <IconButton
              icon={'arrow-back'}
              size={24}
              onPress={() => navigation.goBack()}
              iconColor={styles.iconColor.color}
            />
          )}
          {showCurrentUnit ? (
            <Text numberOfLines={1} style={styles.title}>{`Unit ${
              defaultUnit?.unitNickname
                ? defaultUnit?.unitNickname
                : defaultUnit?.unit?.unitName
            } ${title}`}</Text>
          ) : (
            <Text style={styles.title}>{title}</Text>
          )}
          {hasFilter && (
            <IconButton
              icon={'filter'}
              size={24}
              style={styles.iconButton}
              onPress={() => onClickFilter()}
              iconColor={styles.iconColor.color}
            />
          )}
          {hasAccessCard && (
            <IconButton
              icon={({color}) => (
                <MaterialCommunityIcon
                  name="badge-account-horizontal-outline"
                  color={color}
                  size={24}
                />
              )}
              style={styles.iconButton}
              onPress={() => onClickAccessCard()}
              iconColor={styles.iconColor.color}
            />
          )}
          {hasSearch && (
            <IconButton
              icon="search-outline"
              size={24}
              onPress={() => onClickSearch()}
              iconColor={styles.iconColor.color}
            />
          )}
          <IconButton
            icon={'add'}
            size={28}
            onPress={() => (hasAdd ? onClickAdd() : null)}
            borderless
            style={{
              opacity: hasAdd ? 1 : 0,
            }}
            iconColor={
              hasAdd ? styles.iconColor.color : colorSwatches.primary.color
            }
          />
          {hasMoreMenu && (
            <Menu
              // placement="top"
              trigger={triggerProps => {
                return (
                  <Pressable {...triggerProps} style={styles.moreMenu}>
                    <Ionicon
                      name="ellipsis-vertical"
                      size={22}
                      color={styles.iconColor.color}
                    />
                  </Pressable>
                );
              }}>
              {hasProfile && (
                <Menu.Item onPress={() => openProfile()}>Profile</Menu.Item>
              )}
              {hasOthers && (
                <Menu.Item onPress={() => openOthers()}>Others</Menu.Item>
              )}
              {hasReadAll && (
                <Menu.Item onPress={() => setIsReadAllOpen(true)}>
                  Mark all alerts as read
                </Menu.Item>
              )}
              {hasSwitchUnit && (
                <Menu.Item onPress={() => switchUnit()}>Switch unit</Menu.Item>
              )}
              {hasSignOut && (
                <Menu.Item onPress={() => setIsOpen(!isOpen)}>
                  Sign Out
                </Menu.Item>
              )}
            </Menu>
          )}
        </HStack>
        <ConfirmationDialog
          isOpen={isOpen}
          onClose={onClose}
          onNoPressed={onNoPressed}
          onYesPressed={onYesPressed}
          description="Are you sure you wish to logout?"
        />
        <ConfirmationDialog
          isOpen={isReadAllOpen}
          onClose={onCloseReadAll}
          onNoPressed={onNoPressed}
          onYesPressed={readAll}
          description="Are you sure you wish to mark all alerts as read ?"
        />
      </View>
      {!!pendingOwnerApprovalsCount && (
        <PendingApprovalsBadge
          pendingApprovals={pendingOwnerApprovalsCount}
          onPress={onApprovalsBadgePress}
        />
      )}
    </Center>
  );
};

const createStyles = (isFoldable: boolean = false) => StyleSheet.create({
  navBar: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: Platform.OS === 'ios' ? 0 : 8,
    backgroundColor: colorSwatches.primary.color,
    paddingRight: 10,
  },
  title: {
    fontSize: 18,
    flex: 1,
    color: colorSwatches.white.color,
    marginLeft: 12,
  },
  iconButton: {
    marginTop: 8,
  },
  iconColor: {
    color: 'white',
  },
  moreMenu: {
    paddingLeft: 8,
    paddingRight: 16,
  },
  center: {
    backgroundColor: 'blue', // Replace with your primary color
  },
});

export default NavbarWithAction;
